export const validateResetPasswordLinkOptions = {
  options: ({store}) => {
    const {token} = store.router.queryParams ? store.router.queryParams : 'null';
    return {
      variables: {token},
      fetchPolicy: 'network-only',
      skip: !token
    };
  }
};

export const validateSetPasswordLinkOptions = {
  options: ({store}) => {
    const {token} = store.router.queryParams ? store.router.queryParams : {};
    return {
      variables: {token},
      fetchPolicy: 'network-only',
      skip: !token
    };
  }
};
